import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PopupDriverScheduleRoutingModule } from './popup-driver-schedule-routing.module';
import { DriverScheduleModule } from '../driver-schedule/driver-schedule.module';
import { PopupDriverScheduleComponent } from './popup-driver-schedule.component';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { Trip2ThemeModule } from 'app/trip2-theme/trip2-theme.module';

@NgModule({
  imports: [
    CommonModule,
    PopupDriverScheduleRoutingModule,
    DriverScheduleModule,
    Trip2ThemeModule
  ],
  declarations: [PopupDriverScheduleComponent],
  providers: [
    T2LoadingService
  ]
})
export class PopupDriverScheduleModule { }



// WEBPACK FOOTER //
// ./src/app/pages/popup-driver-schedule/popup-driver-schedule.module.ts